var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mars-ape-layout-footer"},[_c('div',{staticClass:"mars-ape-layout-footer-copyright"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(_vm._s(_vm.siteInfo.copyright||"Copyright 2021~2026 杭州缇苏文化传播有限公司 | 备案号：浙ICP备18052836号-1"))])]),_c('div',{staticClass:"mars-ape-layout-footer-link"})])
}
var staticRenderFns = []

export { render, staticRenderFns }